export enum StorageType {
	USER = 'user',
	PHONE = 'phone',
	PHONE_PREFIX = 'prefix',
	JWT_TOKEN = 'jwtToken',
	LOCALE = 'lang',
	TRANSLATIONS = 'translations',
}
